import { instanceUpload, instance, errorService } from '@/services/api'
import {
  masterAPIs,
  projectAPIs,
  templateAPIs,
} from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { getDimensions, showNotification } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import { checkEvents, socketEvents } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'uploadedFile',
    'name',
    'type',
    'columnDefs',
    'updateType',
    'value',
    'templateId',
    'projectId',
  ],
  data: function() {
    return {
      visible: false,
      process: false,
      data: null,
      duration: 0,
      datafromSocket: null,
      processContent: `Your request for uploading ${this.name} will be processed shortly...`,
      updateList: [],
      selectedRowData: [],
      gridOptions: gridProperties.import.gridOptions,
      defaultColDef: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: false,
      addedCount: 0,
      updatedCount: 0,
      failedCount: 0,
    }
  },
  created: function() {
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.messageReceived)
    // this.$root.$on('socket-message', this.messageReceived)
  },
  beforeDestroy() {
    // this.$socketHub.$off('message-received')
  },
  mounted() {
    this.importFile()
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.duration = null
      this.selectedRowData = []
      this.$emit('clickedCancel', this.addedCount)
    },

    importFile() {
      this.$notification.info({
        message: 'Import Request',
        description: (
          <div>
            <div>
              Your request for importing {this.name} will be processed shortly.
            </div>
            <div>You will be notified once the request is completed</div>
          </div>
        ),
        duration: 5,
      })
      const formdata = new FormData()
      formdata.append('file', this.uploadedFile)
      let url = masterAPIs.import(this.type.toLowerCase(), this.value)
      if (this.type !== 'PROJECT_TENANT' && this.type !== 'TEMPLATE_TENANT') {
        let typeOfdata = this.type.replace('_', '-')
        if (this.type === 'HISTORICAL_COST_INDEX') {
          typeOfdata = 'HISTORICAL-COST-INDEX'
        }
        url = masterAPIs.importMaster(typeOfdata.toLowerCase())
      }
      instanceUpload
        .post(url, formdata)
        .then(response => {
          if (response.data.message) {
            this.$notification.destroy()
            showNotification('info', 'Import', response.data.message)
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    // Socket listen
    messageReceived: function(message) {
      this.loading = false
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      const type = _.get(data.Result, 'Type', '')
      if (data.EventType === 'Error') {
        showNotification(
          'warning',
          'Import',
          _.get(data.Result, 'Message', ''),
        )
        this.$emit('updateTableData')
      }
      if (
        data.EventType === 'BulkUpdates' &&
        _.get(data.Result, 'Type', '') === this.type
      ) {
        this.updatedCount =
          parseInt(_.get(data.Result, 'TotalCount', 0)) -
          parseInt(_.get(data.Result, 'FailedCount', 0))
        this.failedCount = parseInt(_.get(data.Result, 'FailedCount', 0))
        if (this.failedCount === 0 && this.updatedCount > 0) {
          showNotification(
            'success',
            'Import',
            `${this.updatedCount} records updated.`,
          )
        }
        if (this.failedCount > 0 && this.updatedCount > 0) {
          showNotification(
            'success',
            'Import',
            `${this.updatedCount} records updated. ${this.failedCount} records failed to updated`,
          )
        }
        if (this.failedCount > 0 && this.updatedCount === 0) {
          showNotification(
            'warning',
            'Import',
            `${this.failedCount} record failed to updated`,
          )
        }
        this.displayNotification()
        this.$emit('updateTableData')
      }
      if (data.EventType === socketEvents.fileImported && type === this.type) {
        if (data.Status === 'SUCCESS') {
          this.updateList = _.get(data.Result, 'UpdateList', [])
          this.addedCount = _.get(data.Result, 'AddedCount', 0)
          if (this.updateList && this.updateList.length > 0) {
            this.visible = true
          } else if (this.addedCount > 0) {
            this.$notification.success({
              message: 'Import',
              description: h => (
                <div>
                  <div>
                    <b>
                      {this.addedCount} / {data.Result.TotalCount}
                    </b>{' '}
                    {this.name.toLowerCase()}
                    {this.addedCount > 0 ? 's' : ''} added.
                  </div>
                </div>
              ),
              duration: 5,
            })
            this.$emit('updateTableData')
          } else {
            this.$notification.error({
              message: 'Import',
              description: h => (
                <div>
                  <div>
                    There was an error while importing the{' '}
                    {this.name.toLowerCase()}.
                  </div>
                  <div>No record added in the database.</div>
                  <div>Please try again.</div>
                </div>
              ),
            })
            this.$emit('updateTableData')
          }
          data['name'] = this.name
        } else if (data.Status === 'ERROR') {
          this.$emit('clickedCancel')
          showNotification(
            'warning',
            'Import',
            _.get(data.Result, 'Message', ''),
          )
        } else {
          showNotification(
            'warning',
            'Import',
            _.get(data.Result, 'Message', ''),
          )
          this.$emit('updateTableData')
        }
      } else if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === 'Error') {
        showNotification(
          'error',
          'Error',
          'There was an error while importing file. Please try again or contact administrator.',
        )
      }
    },

    saveData() {
      if (this.name === 'Tenant') {
        this.saveTenant()
      } else {
        this.save()
      }
    },

    save() {
      this.loading = true
      const result = []
      this.selectedRowData = this.selectedRowData.map((element, index) => {
        result.push({})
        _.each(element, (value, key) => {
          key =
            key
              .replace(/_/g, '')
              .charAt(0)
              .toLowerCase() + key.replace(/_/g, '').slice(1)
          result[index][key] = value
        })
        return element
      })
      const typeOfdata = this.updateType.replace('_', '-')
      instance
        .patch(masterAPIs.updateImport(typeOfdata.toLowerCase()), result)
        .then(response => {})
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    saveTenant() {
      this.loading = true
      let url = templateAPIs.buildingGeneral.tenant.bulkUpdateTenant(
        this.templateId,
      )
      if (this.type === 'PROJECT_TENANT') {
        url = projectAPIs.project.asset.buildingGeneral.tenant.bulkUpdate(
          this.projectId,
          this.value,
        )
      }
      instance
        .patch(url, this.selectedRowData)
        .then(response => {})
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    getData(params) {
      this.selectedRowData = []
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      this.tableParams = params
      this.height = getDimensions(params, this.height, this.updateList)
    },

    displayNotification() {
      let description = null
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name.charAt(0).toUpperCase() +
          this.name.slice(1)} is imported successfully. ${
          this.addedCount
        } new records added and ${
          this.updatedCount
        } records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name.charAt(0).toUpperCase() +
          this.name.slice(1)} is imported successfully. ${
          this.addedCount
        } new records added and ${
          this.updatedCount
        } records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name.charAt(0).toUpperCase() +
          this.name.slice(1)} is imported successfully. ${
          this.updatedCount
        } records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name.charAt(0).toUpperCase() +
          this.name.slice(1)} is imported successfully. ${
          this.updatedCount
        } records updated successfully. ${
          this.failedCount
        } records failed to update`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount === 0 &&
        this.failedCount > 0
      ) {
        description = `${this.failedCount} records failed to update`
        showNotification('success', 'Import', description)
      }
      if (this.addedCount > 0) {
        description = `${this.name.charAt(0).toUpperCase() +
          this.name.slice(1)} is imported successfully. ${
          this.addedCount
        } new records added successfully.`
        showNotification('success', 'Import', description)
      }
    },
  },
}
